module.exports = __webpack_public_path__ + "img/blur.d066585a.svg";